import { svaraApi } from '../utils/axiosInstance';

/**
 * Svara VIP Arcade catalog as served by gateway-game (`/api/arcade/games`). The game
 * packs talk to the backend themselves; the app needs the catalog only to render the
 * entry screen (locked / coming-soon / round-in-progress states per game). Mirrors
 * `ArcadeCatalogResponseDto` in trinity-nest.
 */
export type ArcadeGameType =
	| 'higher_lower'
	| 'lucky_wheel'
	| 'plinko'
	| 'treasure_chests'
	| 'penalty_shootout'
	| 'crash'
	| 'crossy_road';

export type ArcadeAccessDenialReason =
	| 'disabled'
	| 'coming_soon'
	| 'vip_required'
	| 'limit_reached'
	| 'outside_schedule';

export interface ArcadeCatalogGame {
	gameType: ArcadeGameType;
	status: 'available' | 'coming_soon';
	order: number;
	access: {
		canPlay: boolean;
		reason?: ArcadeAccessDenialReason;
		chipsEntry: boolean;
		ticketEntry: boolean;
		freeEntry: boolean;
	};
	hasActiveRound: boolean;
}

export interface ArcadeCatalogResponse {
	enabled: boolean;
	player: {
		isVip: boolean;
		balance: { chips: number; tickets: number };
		dailyTicketGranted: boolean;
	};
	games: ArcadeCatalogGame[];
	serverTime: string;
}

export async function getArcadeCatalog(): Promise<ArcadeCatalogResponse> {
	const response = await svaraApi.get<ArcadeCatalogResponse>('/api/arcade/games');
	return response.data;
}

/** Pack folder of each playable game, relative to the arcade pack root. */
export const ARCADE_GAME_PACK_DIRS: Partial<Record<ArcadeGameType, string>> = {
	higher_lower: 'higher-lower',
	lucky_wheel: 'lucky-wheel',
	plinko: 'plinko',
	treasure_chests: 'treasure-chests',
};
